
import { LayoutDesplegable } from "../../layouts";
import { FormularioCrearGasto, TablaVerGastos } from "../components";
import { useListGastosTodos } from "../../../hooks/cache";
import { CargandoMedio, ModalFormulario } from "../../components";
import { BusquedaFechas } from "../../components/buscadores";
import { useModalStore } from "../../../stores";
import { useNavigate } from "react-router-dom";
import { iconos } from "../../../data";





export const GastosScreen = () => {

    
    const navigate = useNavigate();
    const { data, isLoading, totalesGastosCaja, chagePage, page, inicio, chageInicio, final, chageFinal } = useListGastosTodos();
    const { modalFormToggle, tipo } = useModalStore();

    const menu = [ 
        { title: 'Crear Gasto', action:() => modalFormToggle(true, 'createUpdateGasto'), icon: iconos['plus'] },
        { title: 'Pagina Anterior', action:() => navigate(-1), icon: iconos['back'] },
    ];



    const handleCerrarModal = () => {
        // setActivarInventario(null);
        modalFormToggle(false);
    }


    return (


    
        <LayoutDesplegable titulo='Gastos Basicos' subtitulo={`información de gastos`} menu={menu}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de ventas..." />
            :   <>
                <BusquedaFechas mT={2}
                    inicio={inicio} chageInicio={chageInicio}
                    final={final} chageFinal={chageFinal} 
                />
                <TablaVerGastos data={data || []} chagePage={chagePage} page={page}  totales={totalesGastosCaja.data || {}} />
                </>
            }



            {(tipo === 'createUpdateGasto') &&
            <ModalFormulario titulo={`${(null) ? 'Editar' : 'Crear' } Gasto`} valor={{}} onClose={ handleCerrarModal }>
                <FormularioCrearGasto handleCerrarModal={handleCerrarModal} />
            </ModalFormulario>
            }
        </LayoutDesplegable>

    )

}
